module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-panel md-elevation-1",
    attrs: {
      "id": "task-form"
    }
  }, [_c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progressTaskFormCard),
      expression: "progressTaskFormCard"
    }]
  }, [_c('div', {
    staticClass: "md-layout"
  }, [_c('div', {
    staticClass: "md-layout-item"
  }, [(!_vm.$route.params.dealid) ? _c('md-button', {
    staticClass: "md-accent md-dense",
    attrs: {
      "to": {
        name: _vm.task.id ? 'Task' : 'Tasks',
        params: {
          groupid: _vm.$route.params.groupid,
          projectid: _vm.$route.params.projectid,
          taskid: _vm.$route.params.taskid
        },
        query: {
          search: _vm.$route.query.search,
          responsible_id: _vm.$route.query.responsible_id,
          responsible: _vm.$route.query.responsible
        }
      }
    }
  }, [_vm._v("Отмена")]) : _vm._e(), (_vm.$route.params.dealid && !_vm.$route.params.taskid) ? _c('md-button', {
    staticClass: "md-accent md-dense",
    attrs: {
      "to": {
        name: 'DealEdit',
        params: {
          dealid: _vm.$route.params.dealid
        }
      }
    }
  }, [_vm._v("Отмена")]) : _vm._e(), (_vm.$route.params.dealid && _vm.$route.params.taskid) ? _c('md-button', {
    staticClass: "md-accent md-dense",
    attrs: {
      "to": {
        name: 'DealTask',
        params: {
          dealid: _vm.$route.params.dealid,
          taskid: _vm.$route.params.taskid
        }
      }
    }
  }, [_vm._v("Отмена")]) : _vm._e()], 1), _c('div', {
    staticClass: "md-layout-item md-layout md-alignment-top-right"
  }, [_c('md-button', {
    staticClass: "md-primary md-dense",
    on: {
      "click": _vm.saveTask
    }
  }, [_vm._v("Сохранить")])], 1)]), _c('md-field', {
    class: {
      'md-invalid': _vm.errors.has('name')
    }
  }, [_c('label', [_vm._v("Название")]), _c('md-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "required": "required",
      "name": "name"
    },
    model: {
      value: (_vm.task.name),
      callback: function($$v) {
        _vm.$set(_vm.task, "name", $$v)
      },
      expression: "task.name"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])], 1), _c('md-field', [_c('label', [_vm._v("Описание")]), _c('md-textarea', {
    model: {
      value: (_vm.task.description),
      callback: function($$v) {
        _vm.$set(_vm.task, "description", $$v)
      },
      expression: "task.description"
    }
  })], 1), _c('autocomplete', {
    attrs: {
      "items": _vm.users,
      "placeholder": "Исполнитель",
      "label": "Исполнитель",
      "showOnFocus": true,
      "callback": _vm.searchUsers,
      "display-property": "login",
      "property": "id",
      "return": "id",
      "name": "responsible_login",
      "id": "responsible_login"
    },
    on: {
      "select": _vm.selectResponsible
    },
    model: {
      value: (_vm.task.responsible_id),
      callback: function($$v) {
        _vm.$set(_vm.task, "responsible_id", $$v)
      },
      expression: "task.responsible_id"
    }
  }), _c('md-field', {
    class: {
      'md-invalid': _vm.errors.has('deadline'),
      'md-has-value': _vm.task.deadline
    }
  }, [_c('label', [_vm._v("Крайний срок")]), _c('datetime', {
    attrs: {
      "input-class": "md-input",
      "type": "datetime",
      "use12-hour": false,
      "week-start": 1,
      "phrases": {
        ok: 'Ок',
        cancel: 'Отмена'
      }
    },
    model: {
      value: (_vm.task.deadline),
      callback: function($$v) {
        _vm.$set(_vm.task, "deadline", $$v)
      },
      expression: "task.deadline"
    }
  }), _c('md-button', {
    staticClass: "md-icon-button md-dense",
    on: {
      "click": function($event) {
        _vm.task.deadline = ''
      }
    }
  }, [_c('md-icon', [_vm._v("close")])], 1), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('deadline')),
      expression: "errors.has('deadline')"
    }],
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.first('deadline')))])], 1), _c('md-field', {
    class: {
      'md-invalid': _vm.errors.has('project_id')
    }
  }, [_c('label', [_vm._v("Проект")]), _c('md-select', {
    attrs: {
      "name": "project_id"
    },
    model: {
      value: (_vm.task.project_id),
      callback: function($$v) {
        _vm.$set(_vm.task, "project_id", $$v)
      },
      expression: "task.project_id"
    }
  }, _vm._l((_vm.projects), function(project) {
    return _c('md-option', {
      key: project.id,
      attrs: {
        "value": project.id
      }
    }, [_vm._v(_vm._s(project.name))])
  })), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('project_id')),
      expression: "errors.has('project_id')"
    }],
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.first('project_id')))])], 1), (_vm.task.project_id) ? _c('md-field', {
    class: {
      'md-invalid': _vm.errors.has('status_id')
    }
  }, [_c('label', [_vm._v("Категория")]), _c('md-select', {
    attrs: {
      "name": "status_id"
    },
    model: {
      value: (_vm.task.status_id),
      callback: function($$v) {
        _vm.$set(_vm.task, "status_id", $$v)
      },
      expression: "task.status_id"
    }
  }, _vm._l((_vm.projectStatuses), function(status) {
    return (status.project_id == _vm.task.project_id) ? _c('md-option', {
      key: status.id,
      attrs: {
        "value": status.id
      }
    }, [_vm._v(_vm._s(status.name))]) : _vm._e()
  })), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('status_id')),
      expression: "errors.has('status_id')"
    }],
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.first('status_id')))])], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68bc3dba","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tasks/views/TaskForm.vue
// module id = 1172
// module chunks = 0